import React from 'react';
import { ReferentIndex } from '../../../_common/referent';
import { Message } from '../_common/message';

export const Referent = () => {
    return (
        <React.Fragment>
            <ReferentIndex hasFooter={false} />
            <Message />
        </React.Fragment>
    );
}